module.exports = __webpack_public_path__ + "static/media/UN-13.c7b92fbb.jpg";